import React from 'react';
import classNames from 'classnames';
import { useTranslations } from '../../../context/TranslationContext';
import RatingOption from '../../../core/RatingScale/RatingOption';

const AccordionItem = ({ index, name, items, overallScore, toggleState, toggleAccordion }) => {
    const { t } = useTranslations();
    const { answer, icon, label, color } = overallScore || {};

    return (
        <div key={index} className={classNames('accordion-item', {
            'accordion-item-open': toggleState
        })}>
            <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                <p className='title'>{name}</p>
                <span className='candidate-rating'>
                    <span>{t('Overall step impression')}</span>
                    <RatingOption icon={icon} color={color} label={label} readOnly />
                </span>
                <span className={`accordion-arrow ${toggleState ? 'open' : ''}`}>
                    <span className='icon-svg-chevron-down'></span>
                </span>
            </div>

            <div className={classNames('accordion-content', { show: toggleState })}>
                <ul className='competencies-list'>
                    {items.length === 0 && (
                        <li className='text-center spacing-bottom'>{t('No ratings')}</li>
                    )}
                    {items.map(({ answer, attribute_title, icon, label, color }, compIndex) => {
                        return (
                            <li key={compIndex} className='competency-item'>
                                <div className='inner-row'>
                                    <div>
                                        <strong className='attribute'>{attribute_title}</strong>
                                        {answer && (
                                            <div className='competency-comment'>{answer}</div>
                                        )}
                                    </div>
                                    <RatingOption
                                        icon={icon}
                                        color={color}
                                        label={label}
                                        readOnly
                                    />
                                </div>
                            </li>
                        );
                    })}
                </ul>
                {answer && <div className='evaluation-note'>{answer}</div>}
            </div>
        </div>
    );
};

export default AccordionItem;
